export default "<app-site>\n  <div fxLayout fxLayoutAlign=\"center center\">\n    <h2>Welcome to ABB Order Configurator</h2>\n  </div>\n</app-site>"